import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from './env.service';
import { Observable, of } from 'rxjs';
import { GetBankGFFPParams } from '../feature/digital-payment/bank-account/bank-account.models';

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {

  constructor(private http: HttpClient, private envService: EnvService) { }

  // GET - stellaradapterservice/v2/config-data/accounts?digitalProfileId={dpid}
  getBankAccounts(digitalProfileId: string, firebaseAuthToken: string): Observable<any> {
    try {
      const headers = new HttpHeaders({
        'X-Firebase-Auth': firebaseAuthToken
      })
      const result = this.http.get(`${this.envService.apiUrl}/v2/profile/${digitalProfileId}/account`, { headers })
      return result
    } 
    catch (error) {
      console.error('error getBankAccounts', error)
      return of(error)
    }
  }

  // GET - stellaradapterservice/v2/config-data/account-fields?{URL_PARAMS}
  getBankGFFPFields(urlParams: GetBankGFFPParams): Observable<any> {
    const subdivisionParam = urlParams?.destinationCountrySubdivisionCode ? `&destinationCountrySubdivisionCode=${urlParams.destinationCountrySubdivisionCode}` : ''
    const userLanguage = urlParams?.userLanguage ? urlParams.userLanguage : 'en-US'
    const { destinationCountryCode, sendAmount, sendCurrencyCode, receiveCurrencyCode, serviceOptionCode, serviceOptionRoutingCode } = urlParams
    try {
      const result = this.http.get(`${this.envService.apiUrl}/v2/config-data/bank/fields?destinationCountryCode=${destinationCountryCode}${subdivisionParam}&sendAmount=${sendAmount}&sendCurrencyCode=${sendCurrencyCode}&receiveCurrencyCode=${receiveCurrencyCode}&serviceOptionCode=${serviceOptionCode}&serviceOptionRoutingCode=${serviceOptionRoutingCode}&userLanguage=${userLanguage}`)
      return result
    }
    catch (error) {
      console.error('error getBankGFFPFields', error)
      return of(error)
    }
  }

  saveNewBankAccount(sendValidateResponse: any, sendValidatePayload: any, firebaseAuthToken: string): Observable<any> { // Todo: fix type
    try {
      const headers = new HttpHeaders({
        'X-Firebase-Auth': firebaseAuthToken
      })
      const digitalProfileId = sendValidatePayload.digitalProfileId
      const saveBankAccountPayload = {
        targetAccountProfileId: sendValidateResponse.targetAccountProfileId,
        targetAccount: {
          ...sendValidatePayload.targetAccount
        }
      }
      const result = this.http.put(`${this.envService.apiUrl}/v2/profile/${digitalProfileId}/account`, saveBankAccountPayload, { headers })
      return result
    }
    catch (error) {
      console.error('error saveNewBankAccount', error)
      return of(error)
    }
  }
}
